export default __webpack_public_path__ + "static/media/user.c9207524.png";